import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSelectedStore } from '../stores';
import { useMyRole } from './useMyRole';

export enum GuardScope {
    Workspace = 'workspace',
    Project = 'project',
}

export const useAccessGuard = (scope: GuardScope, memberOnly?: boolean) => {
    const { workspace: myWorkspace, project: myProject } = useSelectedStore();
    const navigate = useNavigate();
    const myRole = useMyRole();

    useEffect(() => {
        if (scope === GuardScope.Workspace && !myWorkspace) {
            navigate('/w', { replace: true });
            return;
        }
        if (scope === GuardScope.Project && (!myWorkspace || !myProject)) {
            navigate('/w', { replace: true });
            return;
        }

        if (memberOnly && myRole > 1) {
            navigate('/w', { replace: true });
        }
    }, [myWorkspace, myProject, navigate, scope, myRole]);
};
